import poster from ".././assets/ads/ad_poster.png";
import ".././styles/Advertise.css";


function Advertise() {
    return(
            <>
                <div className="container">
                    <div className="advertise-banner-container" id="top">
                        <div className="advertise-banner">
                            <h1>Advertise with Us</h1>
                        </div>
                    </div>
                </div>
                <div className="container addPadding">
                    <div className="sub-container whyAdvertise">
                        <h2 className="section-title">Why Advertise with Us?</h2>
                        <p>
                            We are excited to announce the recent redesign and update of our website, a vital resource for the vibrant community of over 90,000 Filipino-Canadians 
                            in Manitoba. This platform is not only an essential tool for our members and friends but also a welcoming guide for newcomers to Winnipeg and Manitoba. 
                            It provides crucial information to help them successfully settle in their new home. With its enhanced features, we anticipate that many users will take 
                            advantage of this invaluable resource.
                            <br/><br/>
                            Moreover, our Facebook group boasts an impressive following of 2.4K members, making it the go-to place for updates on our upcoming events and programs. 
                            Many supporters and members rely on this group for quick information. Finally, don't miss the chance to advertise your business during our events, reaching 
                            a diverse audience eager for local offerings. Join us and be part of this incredible community!
                        </p>
                    </div>
                </div>
                <div className="container">
                    <div className="sub-container advertiseForm">
                        <div className="img-container">
                            <img src={poster} className="image"></img>
                        </div>
                        <div className="text-side">
                            <p>
                                <h2 className="section-title">Advertise In Our Website</h2>
                                As a valued corporate donor and supporter of PCCM, we invite you to take advantage of a unique opportunity to showcase your products and services to the 
                                thriving Filipino-Canadian community through our website. Not only will you gain valuable exposure, but your business will also qualify for a tax-deductible 
                                receipt for a portion of your generous contribution. 
                                <br /><br />
                                Please refer to the form for detailed information about our services, the advertising rates, and the easy process. We encourage you to read it thoroughly and 
                                seize this beneficial opportunity!
                            </p>
                            <a href="/documents/WEBSITE_ADS_LETTER.pdf" target="_blank" rel="noopener noreferrer" className="button-2">Launch Website Advertisement Form</a>
                        </div>
                    </div>
                </div>
                <div className="container addPadding">
                    <div className="sub-container whyAdvertise">
                        <h2 className="section-title">Other Forms of Advertisement</h2>
                        <p>
                            We can promote your products and services through our vibrant Facebook group, engaging events, and at our welcoming Centre. Don't hesitate to 
                            reach out for customized advertising solutions that fit your needs. If advertising isn't your priority, consider making a donation to our cause or becoming a 
                            sponsor for one of our exciting events.
                            <br /><br />
                            <i>Please contact the President at president@thenewpccm.com for more options. Alternatively, you can connect with us on our <a href="/contact" className="redirect-page">Contact Us Page</a>.</i>
                        </p>
                    </div>
                </div>
            </>
        );
}

export default Advertise;